import useSWR from 'swr'

import * as T from 'types'

import { fetchWithToken } from '../fetchers'
import { getFetchErrorMessage } from './utils/errorMessageHelpers'

export const titleCheckKey = (listingId?: string) =>
  listingId ? `/title-checks/listing/${listingId}` : null

export const useTitleCheck = (listingId?: string) => {
  const response = useSWR<T.ITitleCheckResponse | T.IServerError>(
    titleCheckKey(listingId),
    fetchWithToken,
  )

  let titleCheck: T.ITitleCheck | null = null
  let comparison: T.ITitleCheckComparison | null = null

  if (response.data && 'titleCheck' in response.data) {
    ;({ titleCheck, comparison } = response.data as T.ITitleCheckResponse)
  }

  const error = getFetchErrorMessage(response, 'title check')

  return {
    ...response,
    titleCheck,
    comparison,
    error,
  }
}
